export const PERMS = {
    READ: 'cargo_types.read',
    UPDATE: 'cargo_types.update',
    DELETE: 'cargo_types.delete',
    CREATE: 'cargo_types.create',
    EXPORT: 'cargo_types.export',
}
